export const CPLN_SECRET: string = "d43c4e52bac834ece0e07941e1b4f905b";
